import { Check } from "@phosphor-icons/react";

export default function JobWizardStepRail({ steps, currentStep, onSelect }) {
  return (
    <div className="border-b border-slate-200 bg-white px-5 py-3" data-testid="job-wizard-step-rail">
      <div className="mb-2 flex items-center justify-between text-[10px] font-bold uppercase tracking-wider text-slate-500">
        <span>Five-step job allotment</span>
        <span className="text-emerald-700">Step {currentStep + 1} of {steps.length}</span>
      </div>
      <div className="mb-3 h-1.5 overflow-hidden bg-slate-100" aria-hidden="true">
        <div
          className="h-full bg-emerald-600 transition-[width] duration-300"
          style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }}
          data-testid="job-wizard-progress"
        />
      </div>
      <div className="grid grid-cols-5 gap-1.5" role="tablist" aria-label="Job allotment steps">
        {steps.map((step, index) => {
          const complete = index < currentStep;
          const current = index === currentStep;
          return (
            <button
              key={step.key}
              type="button"
              onClick={() => index <= currentStep && onSelect(index)}
              data-testid={`job-wizard-step-${index + 1}`}
              disabled={index > currentStep}
              aria-current={current ? "step" : undefined}
              className={`min-w-0 border px-2 py-2 text-left transition-colors ${
                current
                  ? "border-emerald-500 bg-emerald-50"
                  : complete
                    ? "border-emerald-200 bg-emerald-50/60"
                    : "border-slate-200 bg-slate-50"
              }`}
            >
              <span className="flex items-center gap-1.5">
                <span
                  className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] font-bold ${
                    complete || current
                      ? "bg-emerald-600 text-white"
                      : "bg-slate-200 text-slate-500"
                  }`}
                >
                  {complete ? <Check size={11} weight="bold" /> : index + 1}
                </span>
                <span className="hidden truncate text-[10px] font-bold text-slate-700 md:block">
                  {step.label}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}